// extracted by mini-css-extract-plugin
export default {"Offer":"Offer_Offer__ae7gP","Rental":"Offer_Rental__1LQP0","card_container":"Offer_card_container__PnNyt","OfferCard":"Offer_OfferCard__FyRFK"};